/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentMaxPointsEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('ASSIGNMENT_MAX_POINTS_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class AssignmentMaxPointsEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentMaxPointsEnabledSettingParser.decode(input).map(res => new AssignmentMaxPointsEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return AssignmentMaxPointsEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentMaxPointsEnabledSettingParser.encode(data);
    }
    static schema() {
        return AssignmentMaxPointsEnabledSettingParser.schema();
    }
}
